import { gql } from '@/clients/utoniq-core'

export const fragments = {
  gachaTicket: gql`
    fragment gachaTicket on GachaTicket {
      id
      artistId
      name
      thumbnails {
        reward {
          uri
        }
        standard {
          uri
        }
      }
      description
      createdAt
      updatedAt
      serialNumber
      specifiedGachas
      price
      isPurchasable
      artist {
        id
        standalone {
          link {
            common
          }
        }
      }
    }
  `,
  gachaTicketOrder: gql`
    fragment gachaTicketOrder on GachaTicketOrder {
      id
      gachaId
      orderType
      createdAt
      formattedCreatedAt @client
      count
      gachaTicketId
    }
  `,
  gachaTicketSerial: gql`
    fragment gachaTicketSerial on Serial {
      id
      authentication {
        ... on SerialAuthentication {
          authenticatedAt
          expiredAt
        }
      }
      createdAt
      updatedAt
      issueCount
    }
  `,
} as const
